import {
  createHighlightCategoryApi,
  createHighlightSlideApi,
  deleteHighlightCategoryApi,
  deleteHighlightSlideApi,
  getAdminHighlightsApi,
  publishHighlightCategoryApi,
  renameHighlightCategoryApi,
  reorderHighlightCategoriesApi,
  reorderHighlightSlidesApi,
  updateHighlightSlideApi,
} from '../../util/api';
import { getHighlightErrorMessage } from './highlightForm';

export const FETCH_HIGHLIGHTS_REQUEST = 'app/AdminPanelHighlightsPage/FETCH_HIGHLIGHTS_REQUEST';
export const FETCH_HIGHLIGHTS_SUCCESS = 'app/AdminPanelHighlightsPage/FETCH_HIGHLIGHTS_SUCCESS';
export const FETCH_HIGHLIGHTS_ERROR = 'app/AdminPanelHighlightsPage/FETCH_HIGHLIGHTS_ERROR';
export const MUTATE_HIGHLIGHTS_REQUEST = 'app/AdminPanelHighlightsPage/MUTATE_HIGHLIGHTS_REQUEST';
export const MUTATE_HIGHLIGHTS_SUCCESS = 'app/AdminPanelHighlightsPage/MUTATE_HIGHLIGHTS_SUCCESS';
export const MUTATE_HIGHLIGHTS_ERROR = 'app/AdminPanelHighlightsPage/MUTATE_HIGHLIGHTS_ERROR';

const initialState = {
  categories: [],
  fetchInProgress: false,
  fetchError: null,
  mutationInProgress: false,
  mutationError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_HIGHLIGHTS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_HIGHLIGHTS_SUCCESS:
      return { ...state, fetchInProgress: false, categories: action.payload || [] };
    case FETCH_HIGHLIGHTS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: action.payload };
    case MUTATE_HIGHLIGHTS_REQUEST:
      return { ...state, mutationInProgress: true, mutationError: null };
    case MUTATE_HIGHLIGHTS_SUCCESS:
      return { ...state, mutationInProgress: false };
    case MUTATE_HIGHLIGHTS_ERROR:
      return { ...state, mutationInProgress: false, mutationError: action.payload };
    default:
      return state;
  }
}

export const fetchAdminHighlights = () => async dispatch => {
  dispatch({ type: FETCH_HIGHLIGHTS_REQUEST });
  try {
    const response = await getAdminHighlightsApi();
    dispatch({ type: FETCH_HIGHLIGHTS_SUCCESS, payload: response?.data || [] });
    return response?.data || [];
  } catch (error) {
    dispatch({ type: FETCH_HIGHLIGHTS_ERROR, payload: getHighlightErrorMessage(error) });
    throw error;
  }
};

const mutateAndRefresh = request => async dispatch => {
  dispatch({ type: MUTATE_HIGHLIGHTS_REQUEST });
  try {
    const response = await request();
    dispatch({ type: MUTATE_HIGHLIGHTS_SUCCESS });
    await dispatch(fetchAdminHighlights());
    return response?.data;
  } catch (error) {
    dispatch({ type: MUTATE_HIGHLIGHTS_ERROR, payload: getHighlightErrorMessage(error) });
    throw error;
  }
};

export const createCategory = name => mutateAndRefresh(() => createHighlightCategoryApi({ name }));

export const renameCategory = (categoryId, name) =>
  mutateAndRefresh(() => renameHighlightCategoryApi(categoryId, { name }));

export const reorderCategories = categoryIds =>
  mutateAndRefresh(() => reorderHighlightCategoriesApi({ categoryIds }));

export const setCategoryPublication = (categoryId, isPublished) =>
  mutateAndRefresh(() => publishHighlightCategoryApi(categoryId, { isPublished }));

export const deleteCategory = categoryId =>
  mutateAndRefresh(() => deleteHighlightCategoryApi(categoryId));

export const createSlide = payload => mutateAndRefresh(() => createHighlightSlideApi(payload));

export const updateSlide = (slideId, payload) =>
  mutateAndRefresh(() => updateHighlightSlideApi(slideId, payload));

export const reorderSlides = (categoryId, slideIds) =>
  mutateAndRefresh(() => reorderHighlightSlidesApi({ categoryId, slideIds }));

export const deleteSlide = slideId => mutateAndRefresh(() => deleteHighlightSlideApi(slideId));

// Admin data needs the browser's authenticated session cookie. Fetch in the page
// after currentUser is available instead of issuing an unauthenticated SSR request.
export const loadData = () => () => Promise.resolve();
